import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m15.719 8.655-3.094 4.054a.96.96 0 0 1-.68.265.94.94 0 0 1-.68-.273.9.9 0 0 1-.28-.67q0-.397.28-.679l2.579-3.368-2.578-3.368a.91.91 0 0 1-.282-.67q0-.39.282-.671a.93.93 0 0 1 .68-.28q.398 0 .679.28l3.094 4.039q.28.28.281.67 0 .39-.281.67M8 14.986q-.015.046-.047.18-.03.132-.047.179l-.054.163-.079.164-.117.125-.164.109-.21.055-.282.023q-.375 0-.719-.39t-.25-.748L8 .998Q8.265 0 9.5 0q.345 0 .46.366.12.367.009.772zm-3.266-2.285a.94.94 0 0 1-.68.273.96.96 0 0 1-.679-.265L.281 8.655A.91.91 0 0 1 0 7.985q0-.39.281-.671l3.094-4.04a.93.93 0 0 1 .68-.28q.398 0 .68.28.28.282.28.671t-.28.67l-2.579 3.37 2.578 3.367a.92.92 0 0 1 .282.679.9.9 0 0 1-.282.67"
    }, null, -1)
  ]))]))
}
export default { render: render }